import Index from '@/views/common/Index'
import PortalHome from '@/views/portal/home/Home'
import Base from '@/views/portal/setup/base/Base'
import Column from '@/views/portal/setup/column/column'
import Welcome from '@/views/portal/situation/welcome/Welcome'
import Characteristic from '@/views/portal/situation/characteristic/Characteristic'
import Time from '@/views/portal/situation/time/Time'
import Contact from '@/views/portal/situation/contact/Contact'
import Zcyys from '@/views/portal/exhibitors/zcyys/Zcyys'
import Zhyss from '@/views/portal/exhibitors/zhyss/Zhyss'
import Hzfws from '@/views/portal/exhibitors/hzfws/Hzfws'
import Question from '@/views/portal/question/Question'
import News from '@/views/portal/news/news/News'
import Style from '@/views/portal/news/style/Style'
import Download from '@/views/portal/download/download'
import Zhzy from '@/views/portal/setup/source/Zhzy'
import Gz from '@/views/portal/guide/gz/Gz'
import Fkfs from '@/views/portal/guide/fkfs/Fkfs'
import Zwsq from '@/views/portal/guide/zwsq/Zwsq'
import Zzbf from '@/views/portal/guide/zzbf/Zzbf'
import Zzsx from '@/views/portal/guide/zzsx/Zzsx'
import Hotel from '@/views/portal/service/hotel/Hotel'
import Restaurant from '@/views/portal/service/restaurant/Restaurant'
import Yqlj from '@/views/portal/setup/yqlj/Yqlj'
import Hzhb from '@/views/portal/setup/hzhb/Hzhb'

import Redirect from '@/views/common/Redirect'


export default [
{
  path: '/index',
  name: 'index',
  redirect: 'portal/home',
  meta: { auth: true },
  component: Index,
  children: [
    //----------首页----------
    {
      path: '/portal/home',
      meta: {auth: true, title: "首页"},
      component: PortalHome,
      children: [
        {
          path: '/',
          name: 'portal/home',
          component: resolve => require(['@/views/portal/home/homeList'], resolve)
        }
      ]
    },



    //----------首页设置----------
    {
      path: '/portal/base',
      meta: {auth: true, title: "首页设置", isRedirect: true },
      component: Base,
      children: [
        {
          path: '/',
          name: 'portal/base',
          component: resolve => require(['@/views/portal/setup/base/BaseList'], resolve)
        }
      ]
    },
    // 富文本文件重定向
    {
      path: '/portal/redirect',
      meta: {auth: false, isRedirect: true},
      component: Redirect,
      children: [
        {
          path: '/',
          name: 'portal/redirect',
          meta: {keepAlive: false},
          component: resolve => require(['@/views/common/Redirect'], resolve)
        }
      ]
    },
    //----------栏目管理----------
    {
      path: '/portal/column',
      meta: { auth: true, title: "栏目管理", isRedirect: true },
      component: Column,
      children: [
        {
          path: '/',
          name: 'column',
          component: resolve => require(['@/views/portal/setup/column/ColumnList'], resolve)
        },
      ]
    },
    //----------展会欢迎辞----------
    {
      path: '/portal/welcome',
      meta: {auth: true, title: "展会欢迎辞", isRedirect: true},
      component: Welcome,
      children: [
        {
          path: '/',
          name: 'welcome',
          meta: {keepAlive: false},
          component: resolve => require(['@/views/portal/situation/welcome/WelcomeList'], resolve)
        },
        //展会欢迎词详情
        {
          path: '/portal/welcome/detail',
          meta: { auth: true, title: "展会欢迎词详情" },
          name: 'welcomeDetail',
          component: resolve => require(['@/views/portal/situation/welcome/WelcomeDetail'], resolve)
        },
        //展会欢迎词新增
        {
          path: '/portal/welcome/insert',
          meta: { auth: true, title: "展会欢迎词新增" },
          name: 'welcomeAdd',
          component: resolve => require(['@/views/portal/situation/welcome/WelcomeEdit'], resolve)
        },
        //展会欢迎词编辑
        {
          path: '/portal/welcome/update',
          meta: { auth: true, title: "展会欢迎词编辑" },
          name: 'welcomeEdit',
          component: resolve => require(['@/views/portal/situation/welcome/WelcomeEdit'], resolve)
        },
      ]
    },

    //----------展会特点----------
    {
      path: '/portal/characteristic',
      meta: { auth: true, title: "展会特点", isRedirect: true },
      component: Characteristic,
      children: [{
          path: '/',
          name: 'characteristic',
          component: resolve => require(['@/views/portal/situation/characteristic/CharacteristicList'], resolve)
        },
        //展会特点详情
        {
          path: '/portal/characteristic/detail',
          meta: { auth: true, title: "展会特点详情" },
          name: 'characteristicDetail',
          component: resolve => require(['@/views/portal/situation/characteristic/CharacteristicDetail'], resolve)
        },
        //展会特点新增
        {
          path: '/portal/characteristic/insert',
          meta: { auth: true, title: "展会特点新增" },
          name: 'characteristicAdd',
          component: resolve => require(['@/views/portal/situation/characteristic/CharacteristicEdit'], resolve)
        },
        //展会特点编辑
        {
          path: '/portal/characteristic/update',
          meta: {auth: true, title: "展会特点编辑" },
          name: 'characteristicEdit',
          component: resolve => require(['@/views/portal/situation/characteristic/CharacteristicEdit'], resolve)
        },
      ]
    },

    //----------展会时间安排----------
    {
      path: '/portal/time',
      meta: { auth: true, title: "展会时间安排", isRedirect: true },
      component: Time,
      children: [{
          path: '/',
          name: 'time',
          component: resolve => require(['@/views/portal/situation/time/TimeList'], resolve)
        },
      ]
    },

    //----------联系我们----------
    {
      path: '/portal/contact',
      meta: { auth: true, title: "联系我们", isRedirect: true},
      component: Contact,
      children: [
        {
          path: '/',
          name: 'contact',
          component: resolve => require(['@/views/portal/situation/contact/ContactList'], resolve)
        },
      ]
    },

		//----------展会指南管理----------
    {
      path: '/portal/gz',
      meta: {auth: true, title: "观众参展指南", isRedirect: true},
      component: Gz,
      children: [
        {
          path: '/',
          name: 'gzList',
          component: resolve => require(['@/views/portal/guide/gz/GzList'], resolve)
        },
        {
          path: '/portal/gz/detail',
          name: 'gzDetail',
          meta: {auth: true, title: "观众参展指南详情"},
          component: resolve => require(['@/views/portal/guide/gz/GzDetail'], resolve)
        },
        {
          path: '/portal/gz/insert',
          name: 'gzInsert',
          meta: {auth: true, title: "观众参展指南新增"},
          component: resolve => require(['@/views/portal/guide/gz/GzEdit'], resolve)
        },
        {
          path: '/portal/gz/update',
          name: 'gzUpdate',
          meta: {auth: true, title: "观众参展指南编辑"},
          component: resolve => require(['@/views/portal/guide/gz/GzEdit'], resolve)
        },
      ]
    },


		//----------展商付款方式管理----------
    {
      path: '/portal/fkfs',
      meta: {auth: true, title: "展商付款方式", isRedirect: true},
      component: Fkfs,
      children: [
        {
          path: '/',
          name: 'fkfsList',
          component: resolve => require(['@/views/portal/guide/fkfs/FkfsList'], resolve)
        },
        {
          path: '/portal/fkfs/insert',
          name: 'fkfsInsert',
          meta: {auth: true, title: "展商付款方式新增"},
          component: resolve => require(['@/views/portal/guide/fkfs/FkfsEdit'], resolve)
        },
        {
          path: '/portal/fkfs/update',
          name: 'fkfsUpdate',
          meta: {auth: true, title: "展商付款方式编辑"},
          component: resolve => require(['@/views/portal/guide/fkfs/FkfsEdit'], resolve)
        },
      ]
    },


		//----------展位申请流程----------
    {
      path: '/portal/zwsq',
      meta: {auth: true, title: "展位申请流程", isRedirect: true},
      component: Zwsq,
      children: [
        {
          path: '/',
          name: 'zwsqList',
          component: resolve => require(['@/views/portal/guide/zwsq/ZwsqList'], resolve)
        },
        {
          path: '/portal/zwsq/insert',
          name: 'zwsqInsert',
          meta: {auth: true, title: "展位申请流程新增"},
          component: resolve => require(['@/views/portal/guide/zwsq/ZwsqEdit'], resolve)
        },
        {
          path: '/portal/zwsq/update',
          name: 'zwsqUpdate',
          meta: {auth: true, title: "展位申请流程编辑"},
          component: resolve => require(['@/views/portal/guide/zwsq/ZwsqEdit'], resolve)
        },
      ]
    },


		//----------展会组织办法管理----------
    {
      path: '/portal/zzbf',
      meta: {auth: true, title: "展会组织办法", isRedirect: true},
      component: Zzbf,
      children: [
        {
          path: '/',
          name: 'zzbfList',
          component: resolve => require(['@/views/portal/guide/zzbf/ZzbfList'], resolve)
        },
        {
          path: '/portal/zzbf/insert',
          name: 'zzbfInsert',
          meta: {auth: true, title: "展会组织办法新增"},
          component: resolve => require(['@/views/portal/guide/zzbf/ZzbfEdit'], resolve)
        },
        {
          path: '/portal/zzbf/update',
          name: 'zzbfUpdate',
          meta: {auth: true, title: "展会组织办法编辑"},
          component: resolve => require(['@/views/portal/guide/zzbf/ZzbfEdit'], resolve)
        },
      ]
    },


		//----------展商注意事项----------
    {
      path: '/portal/zzsx',
      meta: {auth: true, title: "展商注意事项", isRedirect: true},
      component: Zzsx,
      children: [
        {
          path: '/',
          name: 'zzsxList',
          component: resolve => require(['@/views/portal/guide/zzsx/ZzsxList'], resolve)
        },
        {
          path: '/portal/zzsx/insert',
          name: 'zzsxInsert',
          meta: {auth: true, title: "展商注意事项新增"},
          component: resolve => require(['@/views/portal/guide/zzsx/ZzsxEdit'], resolve)
        },
        {
          path: '/portal/zzsx/update',
          name: 'zzsxUpdate',
          meta: {auth: true, title: "展商注意事项编辑"},
          component: resolve => require(['@/views/portal/guide/zzsx/ZzsxEdit'], resolve)
        },
      ]
    },

    //----------主场运营商----------
    {
      path: '/portal/zcyys',
      meta: {auth: true, title: "主场运营商", isRedirect: true},
      component: Zcyys,
      children: [
        {
          path: '/',
          name: 'zcyysList',
          component: resolve => require(['@/views/portal/exhibitors/zcyys/ZcyysList'], resolve)
        },
        {
          path: '/portal/exhibitors/detail',
          name: 'zcyysDetail',
          meta: {auth: true, title: "主场运营商详情"},
          component: resolve => require(['@/views/portal/exhibitors/zcyys/ZcyysDetail'], resolve)
        },
        {
          path: '/portal/exhibitors/insert',
          name: 'zcyysInsert',
          meta: {auth: true, title: "主场运营商新增"},
          component: resolve => require(['@/views/portal/exhibitors/zcyys/ZcyysEdit'], resolve)
        },
        {
          path: '/portal/exhibitors/update',
          name: 'zcyysUpdate',
          meta: {auth: true, title: "主场运营商编辑"},
          component: resolve => require(['@/views/portal/exhibitors/zcyys/ZcyysEdit'], resolve)
        },
      ]
    },

    //----------展会运输商----------
    {
      path: '/portal/zhyss',
      meta: {auth: true, title: "展会运输商", isRedirect: true},
      component: Zhyss,
      children: [
        {
          path: '/',
          name: 'zhyssList',
          component: resolve => require(['@/views/portal/exhibitors/zhyss/ZhyssList'], resolve)
        },
        {
          path: '/portal/exhibitors/zhyss/detail',
          name: 'zhyssDetail',
          meta: {auth: true, title: "展会运输商详情"},
          component: resolve => require(['@/views/portal/exhibitors/zhyss/ZhyssDetail'], resolve)
        },
        {
          path: '/portal/exhibitors/zhyss/insert',
          name: 'zhyssInsert',
          meta: {auth: true, title: "展会运输商新增"},
          component: resolve => require(['@/views/portal/exhibitors/zhyss/ZhyssEdit'], resolve)
        },
        {
          path: '/portal/exhibitors/zhyss/update',
          name: 'zhyssEdit',
          meta: {auth: true, title: "展会运输商编辑"},
          component: resolve => require(['@/views/portal/exhibitors/zhyss/ZhyssEdit'], resolve)
        },
      ]
    },

    //----------会展服务商----------
    {
      path: '/portal/hzfws',
      meta: {auth: true, title: "会展服务商", isRedirect: true},
      component: Hzfws,
      children: [
        {
          path: '/',
          name: 'hzfwsList',
          component: resolve => require(['@/views/portal/exhibitors/hzfws/HzfwsList'], resolve)
        },
        {
          path: '/portal/exhibitors/hzfws/insert',
          name: 'hzfwsInsert',
          meta: {auth: true, title: "会展服务商新增"},
          component: resolve => require(['@/views/portal/exhibitors/hzfws/HzfwsEdit'], resolve)
        },
        {
          path: '/portal/exhibitors/hzfws/update',
          name: 'hzfwsUpdate',
          meta: {auth: true, title: "会展服务商编辑"},
          component: resolve => require(['@/views/portal/exhibitors/hzfws/HzfwsEdit'], resolve)
        },
      ]
    },

    //----------展会资源----------
    {
      path: '/portal/zhzy',
      meta: {auth: true, title: "展会资源", isRedirect: true},
      component: Zhzy,
      children: [
        {
          path: '/',
          name: 'zhzyList',
          component: resolve => require(['@/views/portal/setup/source/ZhzyList'], resolve)
        },
        {
          path: '/portal/exhibitors/zhzy/insert',
          name: 'zhzyInsert',
          meta: {auth: true, title: "展会资源新增"},
          component: resolve => require(['@/views/portal/setup/source/ZhzyEdit'], resolve)
        },
        {
          path: '/portal/exhibitors/zhzy/update',
          name: 'zhzyUpdate',
          meta: {auth: true, title: "展会资源编辑"},
          component: resolve => require(['@/views/portal/setup/source/ZhzyEdit'], resolve)
        },
      ]
    },

    //----------友情链接----------
    {
      path: '/portal/yqlj',
      meta: {auth: true, title: "友情链接", isRedirect: true},
      component: Yqlj,
      children: [
        {
          path: '/',
          name: 'yqljList',
          component: resolve => require(['@/views/portal/setup/yqlj/YqljList'], resolve)
        },
      ]
    },
    //----------合作伙伴----------
    {
      path: '/portal/hzhb',
      meta: {auth: true, title: "合作伙伴", isRedirect: true},
      component: Hzhb,
      children: [
        {
          path: '/',
          name: 'portal/hzhb',
          component: resolve => require(['@/views/portal/setup/hzhb/HzhbList'], resolve)
        },
      ]
    },

    //----------常见问题----------
    {
      path: '/portal/question',
      meta: { auth: true, title: "常见问题",isRedirect: true },
      component: Question,
      children: [{
        path: '/',
        name: 'question',
        component: resolve => require(['@/views/portal/question/QuestionList'], resolve)
      }]
    },

    //----------展商参展指南----------


    //----------新闻中心----------
    {
      path: '/portal/news',
      meta: { auth: true, title: "新闻中心管理", isRedirect: true },
      component: News,
      children: [
        {
          path: '/',
          name: 'news',
          component: resolve => require(['@/views/portal/news/news/NewsList'], resolve)
        },
        {
          path: '/portal/news/insert',
          meta: { auth: true, title: "新闻新增"},
          name: 'newsAdd',
          component: resolve => require(['@/views/portal/news/news/NewsEdit'], resolve)
        },
        {
          path: '/portal/news/update',
          meta: { auth: true, title: "新闻编辑"},
          name: 'newsEdit',
          component: resolve => require(['@/views/portal/news/news/NewsEdit'], resolve)
        },
        {
          path: '/portal/news/detail',
          meta: {auth: true, title: "新闻详情"},
          name: 'newsDetail',
          component: resolve => require(['@/views/portal/news/news/NewsDetail'], resolve)
        }
      ]
    },
    
    //----------展会风采----------
    {
      path: '/portal/style',
      meta: {auth: true, title: "展会风采", isRedirect: true},
      component: Style,
      children: [
        {
          path: '/',
          name: 'styleList',
          component: resolve => require(['@/views/portal/news/style/StyleList'], resolve)
        },
        {
          path: '/portal/style/insert',
          name: 'styleInsert',
          meta: {auth: true, title: "展会风采新增"},
          component: resolve => require(['@/views/portal/news/style/StyleEdit'], resolve)
        },
        {
          path: '/portal/style/update',
          name: 'styleUpdate',
          meta: {auth: true, title: "展会风采编辑"},
          component: resolve => require(['@/views/portal/news/style/StyleEdit'], resolve)
        },
      ]
    },

    //----------下载中心----------
    {
      path: '/portal/download',
      meta: { auth: true, title: "下载中心", isRedirect: true },
      component: Download,
      children: [
        {
          path: '/',
          name: 'download',
          component: resolve => require(['@/views/portal/download/DownloadList'], resolve)
        },
      ]
    },

    //----------酒店服务----------
    {
      path: '/portal/hotel',
      meta: {auth: true, title: "酒店服务", isRedirect: true},
      component: Hotel,
      children: [
        {
          path: '/',
          name: 'hotelList',
          component: resolve => require(['@/views/portal/service/hotel/HotelList'], resolve)
        },
        {
          path: '/portal/service/hotel/insert',
          name: 'hotelInsert',
          meta: {auth: true, title: "酒店服务新增"},
          component: resolve => require(['@/views/portal/service/hotel/HotelEdit'], resolve)
        },
        {
          path: '/portal/service/hotel/update',
          name: 'hotelUpdate',
          meta: {auth: true, title: "酒店服务编辑"},
          component: resolve => require(['@/views/portal/service/hotel/HotelEdit'], resolve)
        },
      ]
    },

    //----------餐饮服务----------
    {
      path: '/portal/restaurant',
      meta: {auth: true, title: "餐饮服务", isRedirect: true},
      component: Restaurant,
      children: [
        {
          path: '/',
          name: 'restaurantList',
          component: resolve => require(['@/views/portal/service/restaurant/RestaurantList'], resolve)
        },
        {
          path: '/portal/service/restaurant/insert',
          name: 'restaurantInsert',
          meta: {auth: true, title: "餐饮服务新增"},
          component: resolve => require(['@/views/portal/service/restaurant/RestaurantEdit'], resolve)
        },
        {
          path: '/portal/service/restaurant/update',
          name: 'restaurantUpdate',
          meta: {auth: true, title: "餐饮服务编辑"},
          component: resolve => require(['@/views/portal/service/restaurant/RestaurantEdit'], resolve)
        },
      ]
    },
  ]
}]



// WEBPACK FOOTER //
// ./src/router/portal.js